import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Form, Col, Row, Button } from "react-bootstrap";
import "../../styles/customers/customerDetails.scss";
import { apiHost } from "../../api/apiClient";
import axios from "axios";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import { utcToDate } from "../../utils/dateConvert";
class AssetDetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      customerId: "",
      customerName: "",
      name: "",
      tag1: "",
      tag2: "",
      description: "",
      profiles: [],
      profileId: "",
      profileName: "",
      color: "",
      icon: "",
      notes: "",
      adminNotes: "",
      status: [],
      statusId: "",
      statusName: "",
      id: "",
      created: "",
      updated: "",
    };
  }

  async componentDidMount() {
    console.log("props", this.props);
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.post(
        `${apiHost}/api/Assets/SelectAsset/${this.props.match.params.id}`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      if (response.status == "200") {
        this.setData(response.data);
        this.props.setLoadingPageAction(false);
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);
      console.log(`😱 Axios request failed: ${e}`);
    }
  }

  setData = (data) => {
    const {
      name,
      tag1,
      tag2,
      notes,
      profile,
      status,
      icon,
      description,
      customerName,
      colour,
      adminNotes,
      id,
      dbCreated,
      dbUpdated,
    } = data;

    this.setState({
      name,
      tag1,
      tag2,
      description,
      color: colour,
      icon,
      notes,
      adminNotes,
      customerName,
      profileName: profile,
      statusName: status,
      id,
      created: dbCreated,
      updated: dbUpdated,
    });
  };

  handleOk = () => {
    this.props.history.goBack();
  };

  handleEdit = () => {
    this.props.history.push(`/editAsset/${this.state.id}`);
  };

  render() {
    const {
      name,
      description,
      tag1,
      tag2,
      color,
      icon,
      notes,
      adminNotes,
      profileName,
      statusName,
      customerName,
      id,
      created,
      updated,
    } = this.state;

    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>Asset Details </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper">
              <h1 style={{ padding: 0, margin: 0 }}>Asset Details</h1>
              <span className="underlineText">{name}</span>
              <hr />
              <Form>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Customer
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{customerName}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Name
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{name}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Tag1
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{tag1}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Tag2
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{tag2}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Description
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{description}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Profile
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{profileName}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Colour
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{color}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Icon
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{icon}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Notes
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{notes}</p>
                  </Col>
                </Row>
                <Row hidden={localStorage.getItem('role') === "SystemAdmin" ? false : true}>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Admin Notes
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{adminNotes}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Status
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{statusName}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      ID
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{id}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Created
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{utcToDate(created)}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Updated
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{utcToDate(updated)}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2"></Col>
                  <Col sm="10"></Col>
                </Row>
              </Form>
              <br />
              <div className="footer-menu">
                <Button variant="outline-secondary" onClick={this.handleOk}>
                  Back to List
                </Button>
                &nbsp;
                <Button variant="primary" onClick={this.handleEdit}>
                  Edit
                </Button>
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(AssetDetail);
